<template>
  <div class="banner-box" v-loading="loading > 0">
    <Header :title="title"></Header>
    <div class="container">
      <div class="content">
        <!-- 表格 -->
        <div class="filter-box">
          <div class="left">
            <div class="label">分类：</div>
            <el-select
              v-model="filter.classifyId"
              size="small"
              class="select"
              style="width: 153px;margin-right: 10px"
              placeholder="请选择"
            >
              <el-option :value="0" label="全部"> </el-option>
              <el-option :value="item.id" :label="item.classifyName" v-for="item in categoryList" :key="item.id"></el-option>
            </el-select>
            <div class="label">发布时间：</div>
            <el-date-picker
              style="margin: 0 10px"
              size="small"
              class="date-input"
              v-model="date"
              type="datetimerange"
              align="right"
              unlink-panels
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
            <el-input
              class="input"
              v-model="filter.name"
              style="width: 188px; margin-left: 10px"
              placeholder="输入品牌或产品名称"
              size="small"
            ></el-input>
            <div class="btn-box">
              <button class="search" @click="search">搜索</button>
              <button class="reset" @click="reset">重置</button>
            </div>
          </div>
          <div class="right">
            <div class="btn" @click="toDetail('add')">+ 添加文章</div>
          </div>
        </div>
        <el-table
          :data="list"
          class="order-table table no-border-table"
          ref="orderTable"
          :header-cell-style="{
            border: 'none',
            color: '#333',
            background: '#f6f6f6',
            borderBottom: '1px solid #E8E8E8',
            height: '54px',
          }"
          :row-style="{
            height: '54px',
          }"
        >
          <el-table-column prop="articlePic" align="center" label="主图">
            <div slot-scope="scope">
              <el-image
                class="brand-pic"
                :src="scope.row.articlePic"
                :preview-src-list="[scope.row.articlePic]"
              >
              </el-image>
            </div>
          </el-table-column>
          <el-table-column
            prop="articleTitle"
            align="center"
            label="标题"
          ></el-table-column>
          <el-table-column
            prop="linkProductId"
            align="center"
            label="关联产品"
          >
            <div slot-scope="scope">
              <span v-for="(item, index) in scope.row.linkProduct" :key="index">
                {{ item.name }}
                <span v-if="index !== scope.row.linkProduct.length-1">、</span>
              </span>
            </div>
          </el-table-column>
          <el-table-column
            prop="linkBrandId"
            align="center"
            label="关联品牌"
          >
            <div slot-scope="scope">
              <span v-for="(item, index) in scope.row.linkBrand" :key="index">
                {{ item.name }}
                <span v-if="index !== scope.row.linkBrand.length-1">、</span>
              </span>
            </div>
          </el-table-column>
          <el-table-column
            prop="created"
            align="center"
            label="发布时间"
          ></el-table-column>
          <el-table-column label="操作" align="center" width="360">
            <div
              slot-scope="scope"
              style="display: flex;justify-content: center;"
            >
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="toDetail('edit', scope.row.id)"
                >
                  编辑
                </button>
              </div>
              <div>
                <button
                  size="mini"
                  class="table-btn"
                  @click="deletePlatformArticle(scope.row.id)"
                >
                  删除
                </button>
              </div>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <div class="footer">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          background
          layout="total, prev, pager, next, jumper"
          :page-size="size"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import Header from '../../components/common/header';
export default {
  components: {
    Header
  },
  name: 'banner',
  data() {
    return {
      currentPage: 1, // 当前页码
      size: 20, // 每页条数
      total: 0, // 总页数
      loading: 0, // 加载中
      title: {
        // 页面标题
        firstTitile: '商城设置',
        secondTitle: '资讯文章'
      },
      list: [], // 轮播列表
      date: [],
      articleType: 2,
      categoryType: 2,
      categoryList: [],
      filter: {
        hotBrand: 0,
        brandName: '',
        classifyId: 0,
        name: ''
      },
    };
  },
  mounted() {
    // 获取列表
    this.getPlatformCategoryList();
    this.getPlatformArticleList();
  },
  computed: {},
  methods: {
    // 切换页码
    handleCurrentChange(page) {
      this.currentPage = page;
      this.getPlatformArticleList();
    },
    search(){
      this.getPlatformArticleList();
    },
    reset(){
      this.filter = {
        hotBrand: 0,
        brandName: '',
        classifyId: 0,
        name: ''
      };
      this.date = [];
      this.getPlatformArticleList();
    },
    // 获取轮播列表
    getPlatformArticleList() {
      this.loading++;
      this.filter.begin = this.date[0] || '';
      this.filter.end = this.date[1] || '';
      this.httpGet(this.$root.getPlatformArticleList, {
        articleType: this.articleType,
        page: this.currentPage,
        size: this.size,
        ...this.filter,
      }).then(
        (res) => {
          this.loading--;
          this.list = res.list;
          this.total = res.total;
        },
        (res) => {
          this.loading--;
          this.$message.error(res);
        }
      );
    },
    getPlatformCategoryList() {
    this.loading++;
    this.httpGet(this.$root.getPlatformCategoryList, {
      classifyType: this.categoryType
    }).then(
      (res) => {
        this.loading--;
        this.categoryList = res.list;
        this.total = res.total;
      },
      (res) => {
        this.loading--;
        this.$message.error(res);
      }
    );
  },
    // 删除
    deletePlatformArticle(id) {
      this.$confirm(
        `<p class='title'><i class='icon el-icon-question'></i>提醒</p><p class='text'>确定要删除该文章吗？</p>`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          cancelButtonClass: 'cancel-btn',
          confirmButtonClass: 'confirm-btn',
          customClass: 'confirm-box',
          dangerouslyUseHTMLString: true,
          showClose: false,
          type: 'none'
        }
      ).then(() => {
        this.loading++;
        this.httpDelete(this.$root.deletePlatformArticle, {
          id
        }).then(
          (res) => {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.loading--;
            this.getPlatformArticleList();
          },
          (res) => {
            this.loading--;
            this.$message.error(res);
          }
        );
      });
    },
    toDetail(type, id) {
      this.$router.push({
        name: 'brandArticleDetail',
        query: {
          type,
          id
        }
      });
    },
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus">
@import '~assets/public.styl';
</style>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~assets/main.styl';

.banner-box {
  height: 100%;
  width: 100%;
  flex-y(flex-start, flex-start);
  overflow-y: hidden;
  background: bg-color;

  .container {
    box-sizing: border-box;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    flex-y(flex-start, flex-start);
    padding: 0 20px 20px;

    // content 表格
    .content {
      flex: 1;
      width: 100%;
      font-size: 14px;
      background: white;
      box-sizing: border-box;
      padding: 24px 32px;
      border-radius: 2px;

      .filter-box{
        flex-x();
        .left{
          flex-x(flex-start);
        }
        .btn-box{
          margin-left: 10px;
        }
      }

      // 按钮
      .btn {
        // width: 100px;
        display: inline-block;
        padding: 0 10px;
        height: 32px;
        line-height: 32px;
        confirm-btn();
        font-size: 14px;
        margin-bottom: 16px;
        // margin: 16px 0;
      }

      .tip {
        margin-left: 32px;
        color: #999;
      }

      // 表格按钮
      .table-btn {
        width: 65px;
        height: 24px;
        line-height: 24px;
        color: gray3;
        font-size: 12px;
        margin-right: 8px;
        cancel-btn();
      }

      .brand-pic {
        height: 36px;
        width: auto;
      }
    }
    .footer {
      width: 100%;
      padding: 24px;
      box-sizing: border-box;
      flex-x(flex-end);
      background: white;
    }
  }
}
</style>
